import "./ErrorPage.css"
import { useAtomValue } from "jotai"
import { AccessCode, accessStatusAtom } from "@store/authAtoms"
import Unauthorized from "./Unauthorized"
import Forbidden from "./Forbidden"
import NotFound from "./NotFound"
import SomethingWentWrong from "./SomethingWentWrong"

export enum ErrorStatus {
  AccessDenied = 401,
  Forbidden = 403,
  NotFound = 404,
  SomethingWentWrong = 500,
}

type ErrorPageProps = {
  status: ErrorStatus
  url?: string
}

export default function ErrorPage({ status, url = "" }: ErrorPageProps) {
  const authStatus = useAtomValue(accessStatusAtom)
  if (authStatus.code === AccessCode.UNAUTHORIZED) {
    return <Unauthorized />
  }

  switch (status) {
    case ErrorStatus.NotFound:
      return <NotFound />
    case ErrorStatus.Forbidden:
      return <Forbidden url={url} />
    case ErrorStatus.AccessDenied:
      return <Unauthorized />
    case ErrorStatus.SomethingWentWrong:
      return <SomethingWentWrong />
    default:
      // we should never fall through to here
      return "Help!"
  }
}
